import { profileActionTypes } from './profile.types';

const INITIAL_STATE = {
    profiles: [],
    availablePermissions: [],
};

const profileReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case profileActionTypes.SET_PROFILES:
            return {
                ...state,
                profiles: action.payload
            };
        case profileActionTypes.SET_AVAILABLE_PERMISSIONS:
            return {
                ...state,
                availablePermissions: action.payload
            };
        default:
            return state;
    }
};

export default profileReducer;